import * as React from 'react';

export const Arrow = React.forwardRef<SVGElement>((props, ref) => (
  <svg {...props} ref={ref as any} width={10} height={10} viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <polygon points={'0,0 0,10 10,0'} />
    <polygon points={'0,0 0,7.2 7.2,0'} />
  </svg>
));
